import classnames from 'classnames';
import React, { memo, MutableRefObject, useState } from 'react';

import { Sticky } from '~/Components/Sticky/Sticky';

import { BasicColumn } from './Table';
import styles from './Table.scss';

export interface Header_Props<Column> {
  columns: Array<Column>;
  sort?: string;
  sortDirection?: SortDirection;
  renderCell: (column: Column) => React.ReactNode;
  onCellClick?: (column: Column) => void;
  topOffset: number;

  tableRef: MutableRefObject<HTMLDivElement>;
}

const Header = <Column extends BasicColumn>(props: Header_Props<Column>) => {
  const { columns, sort, sortDirection, topOffset, onCellClick, renderCell, tableRef } = props;

  const [isSticky, setIsSticky] = useState(false);

  const onClick = (column: Column) => () => {
    if (onCellClick) {
      onCellClick(column);
    }
  };

  const header = classnames(styles.header, {
    [styles.stickyHeader]: isSticky,
  });

  return (
    <Sticky topOffset={topOffset} onStickyStateChange={setIsSticky} sentinelId="sentinel-table" wrapperRef={tableRef}>
      <div className={header}>
        {columns.map((column, index) => {
          const isActive = !!sort && !!column.selector && sort === column.selector;
          const headerCell = classnames(styles.headerCell, {
            [styles.headerCellActive]: isActive,
            [`header-cell-${column.selector}`]: true,
          });
          const arrow = classnames(styles.arrow, {
            [styles.arrowActive]: isActive && sortDirection !== 0,
            [styles.arrowUp]: sortDirection === -1,
          });

          return (
            <div key={`header-cell-${index}`} className={headerCell} onClick={onClick(column)}>
              {renderCell(column)}
              <div className={arrow} />
            </div>
          );
        })}
      </div>
    </Sticky>
  );
};

export default memo(Header);
